import { render, staticRenderFns } from "./ProviderIcon.vue?vue&type=template&id=09049f07&scoped=true&"
import script from "./ProviderIcon.vue?vue&type=script&lang=js&"
export * from "./ProviderIcon.vue?vue&type=script&lang=js&"
import style0 from "./ProviderIcon.vue?vue&type=style&index=0&id=09049f07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09049f07",
  null
  
)

export default component.exports